import styled from 'styled-components';
import { Colors, MEDIA } from '@brg/ui';
import { RectangularButtonFilled } from 'shared/components/buttons';

export const Root = styled.div`
    width: 100vw;
    min-height: 100vh;
    background: ${Colors.geoWhite100};
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 24px;
    padding: 48px 24px;
    font-family: Inter, sans-serif;

    @media ${MEDIA.TABLET} {
        padding: 32px 16px;
    }

    @media ${MEDIA.MOBILE} {
        gap: 16px;
        padding: 24px 10px;
    }
`;

export const IllustrationWrap = styled.div`
    position: relative;
    width: 630px;
    height: 471px;
    max-width: 100%;
    flex-shrink: 0;
    overflow: hidden;
    pointer-events: none;

    @media ${MEDIA.LAPTOP} {
        width: 538px;
        height: 403px;
    }

    @media ${MEDIA.MOBILE} {
        width: 374px;
        height: 280px;
    }
`;

export const IllustrationImg = styled.img`
    position: absolute;
    left: 50%;
    top: 50%;
    width: 604px;
    height: 340px;
    max-width: none;
    object-fit: cover;
    transform: translate(-50%, -50%) rotate(17.81deg);

    @media ${MEDIA.LAPTOP} {
        width: 516px;
        height: 290px;
    }

    @media ${MEDIA.MOBILE} {
        width: 359px;
        height: 202px;
    }
`;

export const Inner = styled.div`
    width: 100%;
    max-width: 480px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 40px;
    text-align: center;

    @media ${MEDIA.LAPTOP} {
        gap: 32px;
    }

    @media ${MEDIA.TABLET} {
        gap: 24px;
    }
`;

export const TextBlock = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 16px;

    @media ${MEDIA.TABLET} {
        gap: 8px;
    }
`;

export const Title = styled.h1`
    margin: 0;
    width: 100%;
    font-size: 30px;
    line-height: 40px;
    font-weight: 600;
    letter-spacing: -0.6px;
    color: ${Colors.galBlack100};

    @media ${MEDIA.LAPTOP} {
        font-size: 23px;
        line-height: 27px;
        letter-spacing: -0.46px;
    }

    @media ${MEDIA.MOBILE} {
        font-size: 20px;
        line-height: 25px;
        letter-spacing: -0.4px;
    }
`;

export const Text = styled.p`
    margin: 0;
    width: 100%;
    font-size: 17px;
    line-height: 22px;
    font-weight: 400;
    letter-spacing: -0.34px;
    color: ${Colors.galBlack100};

    @media ${MEDIA.LAPTOP} {
        font-size: 15px;
        line-height: 20px;
        letter-spacing: -0.3px;
    }
`;

export const Actions = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 16px;

    @media ${MEDIA.TABLET} {
        gap: 12px;
    }
`;

export const CtaButton = styled(RectangularButtonFilled)`
    height: 48px !important;
    min-width: unset;
    padding: 13px 48px;
    font-size: 17px;
    line-height: 22px;
    font-weight: 600;
    letter-spacing: -0.34px;
    background: ${Colors.galBlack100};
    color: ${Colors.geoWhite100};

    &:hover,
    &:focus,
    &:active {
        background: #302f2f;
        color: ${Colors.geoWhite100};
    }

    @media ${MEDIA.LAPTOP} {
        height: 40px !important;
        padding: 10px 24px;
        font-size: 15px;
        line-height: 20px;
        letter-spacing: -0.3px;
    }

    @media ${MEDIA.MOBILE} {
        width: 100%;
    }
`;

export const Footnote = styled.p`
    margin: 0;
    width: 100%;
    font-size: 17px;
    line-height: 22px;
    font-weight: 400;
    letter-spacing: -0.34px;
    color: ${Colors.galBlack47};

    @media ${MEDIA.LAPTOP} {
        font-size: 15px;
        line-height: 20px;
        letter-spacing: -0.3px;
    }

    @media ${MEDIA.MOBILE} {
        font-size: 13px;
        line-height: 16px;
        letter-spacing: -0.26px;
    }
`;
import styled from 'styled-components';
import { Colors, MEDIA } from '@brg/ui';
import { RectangularButtonFilled } from 'shared/components/buttons';

export const Root = styled.div`
    width: 100vw;
    min-height: 100vh;
    background: ${Colors.geoWhite100};
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 24px;
    padding: 48px 24px;
    font-family: Inter, sans-serif;

    @media ${MEDIA.TABLET} {
        padding: 32px 16px;
    }

    @media ${MEDIA.MOBILE} {
        gap: 16px;
        padding: 24px 10px;
    }
`;

export const IllustrationWrap = styled.div`
    position: relative;
    width: 630px;
    height: 471px;
    max-width: 100%;
    flex-shrink: 0;
    overflow: hidden;
    pointer-events: none;

    @media ${MEDIA.LAPTOP} {
        width: 538px;
        height: 403px;
    }

    @media ${MEDIA.MOBILE} {
        width: 374px;
        height: 280px;
    }
`;

export const IllustrationImg = styled.img`
    position: absolute;
    left: 50%;
    top: 50%;
    width: 604px;
    height: 340px;
    max-width: none;
    object-fit: cover;
    transform: translate(-50%, -50%) rotate(17.81deg);

    @media ${MEDIA.LAPTOP} {
        width: 516px;
        height: 290px;
    }

    @media ${MEDIA.MOBILE} {
        width: 359px;
        height: 202px;
    }
`;

export const Inner = styled.div`
    width: 100%;
    max-width: 480px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 40px;
    text-align: center;

    @media ${MEDIA.LAPTOP} {
        gap: 32px;
    }

    @media ${MEDIA.TABLET} {
        gap: 24px;
    }
`;

export const TextBlock = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 16px;

    @media ${MEDIA.TABLET} {
        gap: 8px;
    }
`;

export const Title = styled.h1`
    margin: 0;
    width: 100%;
    font-size: 30px;
    line-height: 40px;
    font-weight: 600;
    letter-spacing: -0.6px;
    color: ${Colors.galBlack100};

    @media ${MEDIA.LAPTOP} {
        font-size: 23px;
        line-height: 27px;
        letter-spacing: -0.46px;
    }

    @media ${MEDIA.MOBILE} {
        font-size: 20px;
        line-height: 25px;
        letter-spacing: -0.4px;
    }
`;

export const Text = styled.p`
    margin: 0;
    width: 100%;
    font-size: 17px;
    line-height: 22px;
    font-weight: 400;
    letter-spacing: -0.34px;
    color: ${Colors.galBlack100};

    @media ${MEDIA.LAPTOP} {
        font-size: 15px;
        line-height: 20px;
        letter-spacing: -0.3px;
    }
`;

export const Actions = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 16px;

    @media ${MEDIA.TABLET} {
        gap: 12px;
    }
`;

export const CtaButton = styled(RectangularButtonFilled)`
    height: 48px !important;
    min-width: unset;
    padding: 13px 48px;
    font-size: 17px;
    line-height: 22px;
    font-weight: 600;
    letter-spacing: -0.34px;
    background: ${Colors.galBlack100};
    color: ${Colors.geoWhite100};

    &:hover,
    &:focus,
    &:active {
        background: #302f2f;
        color: ${Colors.geoWhite100};
    }

    @media ${MEDIA.LAPTOP} {
        height: 40px !important;
        padding: 10px 24px;
        font-size: 15px;
        line-height: 20px;
        letter-spacing: -0.3px;
    }

    @media ${MEDIA.MOBILE} {
        width: 100%;
    }
`;

export const Footnote = styled.p`
    margin: 0;
    width: 100%;
    font-size: 17px;
    line-height: 22px;
    font-weight: 400;
    letter-spacing: -0.34px;
    color: ${Colors.galBlack47};

    @media ${MEDIA.LAPTOP} {
        font-size: 15px;
        line-height: 20px;
        letter-spacing: -0.3px;
    }

    @media ${MEDIA.MOBILE} {
        font-size: 13px;
        line-height: 16px;
        letter-spacing: -0.26px;
    }
`;
